import { Injectable, EventEmitter, Output } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';


@Injectable()
export class InformationPageService {

  @Output() save: EventEmitter<any> = new EventEmitter();

  @Output() saved: EventEmitter<any> = new EventEmitter();

  @Output() saveModalOpen: EventEmitter<any> = new EventEmitter();

  @Output() itemsCountChanged: EventEmitter<any> = new EventEmitter();

  @Output() cancel: EventEmitter<any> = new EventEmitter();

  @Output() showBeforeLeavingModal: EventEmitter<any> = new EventEmitter();

  @Output() showBeforeSaveModal: EventEmitter<any> = new EventEmitter();

  canDeactivateSubj: Subject<boolean> = new Subject<boolean>();

  emitSave(data: any) {
    this.save.emit(data);
  }

  emitSaved() {
    this.saved.emit();
  }

  emitSaveModal() {
    this.saveModalOpen.emit();
  }

  emitCancel(data: any) {
    this.cancel.emit(data);
  }

  // items that will be changed
  setItemsCount(count: Number) {
    this.itemsCountChanged.emit(count);
  }

  setCanDeactivate(value: boolean) {
    this.canDeactivateSubj.next(value);
  }

  emitShowBeforeLeavingModal() {
    this.showBeforeLeavingModal.emit();
  }

  emitShowBeforeSaveModal() {
    this.showBeforeSaveModal.emit();
  }
}
